import { VariantGroup } from "../../types/types";

//TODO Is this function understandable, or must we use colour somehow?
export function getColourGroupForVariant(
  variantGroups: VariantGroup[] | undefined,
  variantId: string,
) {
  return variantGroups?.find(
    (group) => group.variants?.some((v) => v.id === variantId),
  );
}
